import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import FloatingContact from '../../components/feature/FloatingContact';
import { useEffect } from 'react';

const Approach = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <FloatingContact />

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-12 md:pb-20 bg-white">
        <div className="max-w-5xl mx-auto px-6 md:px-8 lg:px-20 text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-mid-gray mb-4 md:mb-6 font-sans">
            Tasarım Felsefesi
          </p>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-dark-gray leading-tight mb-6 md:mb-8">
            Mekân, İşlev<br />ve Estetik
          </h1>
          <p className="font-sans text-base md:text-lg text-mid-gray max-w-2xl mx-auto leading-relaxed px-4">
            Mimari tasarımda sadelik, fonksiyonellik ve zamansız estetik anlayışı
          </p>
        </div>
      </section>

      {/* Core Principles */}
      <section className="py-16 md:py-20 bg-cream">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 lg:gap-12">
            <div className="text-center px-4">
              <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 mx-auto mb-4 md:mb-6 flex items-center justify-center">
                <i className="ri-layout-line text-4xl md:text-5xl text-dark-gray"></i>
              </div>
              <h3 className="font-sans text-xl md:text-2xl font-medium text-dark-gray mb-3 md:mb-4">
                Minimalizm
              </h3>
              <p className="text-mid-gray text-xs md:text-sm leading-relaxed">
                Gereksiz detaylardan arındırılmış, saf ve güçlü tasarım dili. Her eleman, mekânın bütünlüğüne anlamlı bir katkı sunar. Sadelik, karmaşıklığın en sofistike halidir.
              </p>
            </div>

            <div className="text-center px-4">
              <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 mx-auto mb-4 md:mb-6 flex items-center justify-center">
                <i className="ri-sun-line text-4xl md:text-5xl text-dark-gray"></i>
              </div>
              <h3 className="font-sans text-xl md:text-2xl font-medium text-dark-gray mb-3 md:mb-4">
                Işık
              </h3>
              <p className="text-mid-gray text-xs md:text-sm leading-relaxed">
                Doğal ışık, mekânın ruhunu belirleyen en temel unsurdur. Gün boyunca değişen ışık oyunları, mekâna dinamizm ve derinlik kazandırır. Işık, mimarlığın görünmez malzemesidir.
              </p>
            </div>

            <div className="text-center px-4">
              <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 mx-auto mb-4 md:mb-6 flex items-center justify-center">
                <i className="ri-stack-line text-4xl md:text-5xl text-dark-gray"></i>
              </div>
              <h3 className="font-sans text-xl md:text-2xl font-medium text-dark-gray mb-3 md:mb-4">
                Malzeme
              </h3>
              <p className="text-mid-gray text-xs md:text-sm leading-relaxed">
                Doğru malzeme seçimi, tasarımın karakterini ve dayanıklılığını belirler. Her malzemenin kendine özgü dokusu, rengi ve yaşlanma biçimi, mekâna zamansız bir kimlik kazandırır.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Detailed Philosophy */}
      <section className="py-16 md:py-20 lg:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-8 lg:px-20">
          <article className="space-y-12 md:space-y-16">
            <div>
              <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mb-4 md:mb-6">
                Mekân ve İnsan İlişkisi
              </h2>
              <p className="font-sans text-sm md:text-base text-mid-gray leading-relaxed mb-3 md:mb-4">
                Mimarlık, insan deneyimini şekillendiren en güçlü araçlardan biridir. Bir mekân, yalnızca fiziksel bir çevre değil, aynı zamanda duygusal ve psikolojik bir etkileşim alanıdır. Bu nedenle, her tasarım kararı kullanıcının yaşam kalitesini artırmayı hedefler.
              </p>
              <p className="font-sans text-sm md:text-base text-mid-gray leading-relaxed">
                Mekânsal organizasyon, dolaşım akışı, ölçek ve oran gibi unsurlar, kullanıcının mekânı nasıl algıladığını ve deneyimlediğini doğrudan etkiler. Bu bağlamda, mimari tasarım bir problem çözme süreci olduğu kadar, bir hikâye anlatma sanatıdır.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mb-4 md:mb-6">
                Fonksiyon ve Estetik Dengesi
              </h2>
              <p className="font-sans text-sm md:text-base text-mid-gray leading-relaxed mb-3 md:mb-4">
                İyi mimarlık, işlevsellik ve estetiğin mükemmel dengesini kurar. Bir mekân ne kadar güzel olursa olsun, kullanıcının ihtiyaçlarını karşılamıyorsa eksik kalır. Benzer şekilde, yalnızca fonksiyonel olan bir tasarım, duygusal bağ kurmakta yetersiz kalabilir.
              </p>
              <p className="font-sans text-sm md:text-base text-mid-gray leading-relaxed">
                Bu denge, her projenin kendine özgü bağlamında yeniden kurulur. Konut projelerinde mahremiyet ve konfor, ticari alanlarda verimlilik ve temsil, özel projelerde ise özgünlük ve karakter ön plana çıkar.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mb-4 md:mb-6">
                Zamansız Tasarım Anlayışı
              </h2>
              <p className="font-sans text-sm md:text-base text-mid-gray leading-relaxed mb-3 md:mb-4">
                Trendlerin ötesinde, zamana direnen tasarımlar yaratmak, mimarlığın en büyük sorumluluklarından biridir. Zamansız bir mekân, yıllar sonra bile ilk günkü tazeliğini ve anlamını korur.
              </p>
              <p className="font-sans text-sm md:text-base text-mid-gray leading-relaxed">
                Bu yaklaşım, klasik oranlar, kaliteli malzemeler ve sade formlar kullanarak, modanın geçiciliğinden uzak, kalıcı değerler yaratmayı hedefler. Sonuç olarak, her proje kendi döneminin ötesinde bir anlam taşır.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mb-4 md:mb-6">
                Sürdürülebilirlik ve Sorumluluk
              </h2>
              <p className="font-sans text-sm md:text-base text-mid-gray leading-relaxed mb-3 md:mb-4">
                Çağdaş mimarlık pratiği, çevresel sorumluluğu göz ardı edemez. Enerji verimliliği, doğal kaynakların akılcı kullanımı ve uzun ömürlü tasarımlar, sürdürülebilir mimarlığın temel ilkeleridir.
              </p>
              <p className="font-sans text-sm md:text-base text-mid-gray leading-relaxed">
                Pasif iklimsel stratejiler, yerel malzeme kullanımı ve esnek mekân organizasyonları, hem çevresel etkiyi azaltır hem de kullanıcıya uzun vadeli ekonomik fayda sağlar. Sürdürülebilirlik, bir seçenek değil, bir gerekliliktir.
              </p>
            </div>
          </article>
        </div>
      </section>

      {/* Visual Section */}
      <section className="py-16 md:py-20 bg-light-gray">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            <div className="relative h-72 md:h-80 lg:h-96 overflow-hidden rounded-lg">
              <img
                src="https://public.readdy.ai/ai/img_res/81c6abaeba3c964a6cff874dcf156d60.jpg"
                alt="Interior Design Philosophy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="relative h-72 md:h-80 lg:h-96 overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Contemporary%20architecture%20detail%20showing%20geometric%20concrete%20structure%2C%20play%20of%20light%20and%20shadow%2C%20minimalist%20design%20elements%2C%20clean%20lines%2C%20textured%20surfaces%2C%20professional%20architectural%20photography%2C%20monochromatic%20tones%2C%20sophisticated%20composition%2C%20ultra%20high%20quality&width=900&height=700&seq=approach-ext-001&orientation=landscape"
                alt="Architectural Details"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Approach;
